import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { switchMap, take } from 'rxjs/operators';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable } from 'rxjs';
const excluderUrls = [
  'oauthCallback',
  'graph.microsoft.com/v1.0/me/photo/$value',
  'graph.microsoft.com',
];

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly afAuth = inject(AngularFireAuth);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (excluderUrls.some((url) => request.url.indexOf(url) !== -1)) {
      return next.handle(request);
    }

    return this.afAuth.idToken.pipe(
      take(1),
      switchMap((token) => {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });

        return next.handle(request);
      })
    );
  }
}
